export const styles = theme => ({
  story: {
    height: '91vh',
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly'
  },
  storyContent: {
    display: 'flex',
    top: 0,
    bottom: 0,
    alignItems: 'center'
  },
  text: {
    padding: theme.spacing(3),
    textAlign: 'left',
    fontSize: 'calc(.8rem + .3vw)'
  },
  picture: {
    minWidth: '200px',
    width: '20vw',
    margin: '2rem 0'
  },
  howTo: {
    height: 'auto',
    minWidth: '350px',
    width: '20vw',
    margin: '0 auto'
  }
});
